<template>
  <div class="vp-btn-row">
    <button
      class="vp-btn"
      title="Fotograma anterior"
      @click="$emit('backward')"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M6 6h2v12H6zm3.5 6 8.5 6V6z" fill="currentColor" />
      </svg>
    </button>
    <button
      class="vp-btn vp-btn--primary"
      :title="isPlaying ? 'Pausar' : 'Reproducir'"
      @click="$emit('play-toggle')"
    >
      <svg
        v-if="isPlaying"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect x="6" y="4" width="4" height="16" fill="currentColor" />
        <rect x="14" y="4" width="4" height="16" fill="currentColor" />
      </svg>
      <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M8 5v14l11-7z" fill="currentColor" />
      </svg>
    </button>
    <button class="vp-btn" title="Detener" @click="$emit('stop')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect x="6" y="6" width="12" height="12" fill="currentColor" />
      </svg>
    </button>
    <button
      class="vp-btn"
      title="Fotograma siguiente"
      @click="$emit('forward')"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M18 6h-2v12h2zm-3.5 6L6 6v12z" fill="currentColor" />
      </svg>
    </button>
    <button class="vp-btn" title="Captura de pantalla" @click="$emit('photo')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
        />
        <circle
          cx="12"
          cy="13"
          r="4"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
        />
      </svg>
    </button>
    <button
      class="vp-btn"
      :class="{ 'vp-btn--success': isCutModeEnabled }"
      :title="isCutModeEnabled ? 'Confirmar corte' : 'Exportar segmento'"
      @click="$emit('video')"
    >
      <svg
        v-if="isCutModeEnabled"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
      >
        <polyline
          points="20,6 9,17 4,12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
      </svg>
      <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none">
        <polygon points="23,7 16,12 23,17" fill="currentColor" />
        <rect x="1" y="5" width="15" height="14" rx="2" fill="currentColor" />
      </svg>
    </button>
    <button class="vp-btn" title="Pantalla completa" @click="$emit('expand')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <polyline
          points="8,3 3,3 3,8"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
        <polyline
          points="21,8 21,3 16,3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
        <polyline
          points="3,16 3,21 8,21"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
        <polyline
          points="16,21 21,21 21,16"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
      </svg>
    </button>
    <div class="vp-speed-group">
      <button
        v-for="s in availableSpeeds"
        :key="s"
        class="vp-speed-btn"
        :class="{ 'vp-speed-btn--active': speed === `x${s}` }"
        @click="$emit('speed', s)"
      >
        {{ s }}×
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoControls",
  props: {
    isPlaying: { type: Boolean, required: true },
    isCutModeEnabled: { type: Boolean, required: true },
    availableSpeeds: { type: Array, required: true },
    speed: { type: String, required: true },
  },
};
</script>

<style>
.vp-btn-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.vp-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--vp-accent-light);
  border: 1.5px solid var(--vp-accent-ring);
  color: var(--vp-accent);
  cursor: pointer;
  transition: all 0.12s;
  flex-shrink: 0;
}
.vp-btn:hover {
  transform: scale(1.09);
  background: rgba(2, 132, 199, 0.2);
}
.vp-btn--primary {
  width: 48px;
  height: 48px;
  background: var(--vp-accent);
  border-color: var(--vp-accent);
  color: #fff;
  box-shadow: 0 4px 14px rgba(2, 132, 199, 0.45);
}
.vp-btn--primary:hover {
  background: #0369a1;
  border-color: #0369a1;
}
.vp-btn--success {
  background: var(--vp-success-bg);
  border-color: rgba(22, 163, 74, 0.4);
  color: var(--vp-success);
}
.vp-btn--success:hover {
  background: rgba(22, 163, 74, 0.2);
}
.vp-speed-group {
  display: flex;
  gap: 5px;
  margin-left: 10px;
}
.vp-speed-btn {
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--vp-accent-light);
  border: 1.5px solid var(--vp-accent-ring);
  color: var(--vp-accent);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  transition: all 0.12s;
}
.vp-speed-btn:hover {
  background: rgba(2, 132, 199, 0.2);
}
.vp-speed-btn--active {
  background: var(--vp-accent);
  border-color: var(--vp-accent);
  color: #fff;
}
</style>
